// AUTO-GENERATED by scripts/inline-icon-svg.mjs. Do not edit by hand.
// Source: assets/images/icon-dark.svg
// In-app logomark (AppHeader, desktop LeftRail).
// Regenerate with: node scripts/inline-icon-svg.mjs

export const LOGO_SVG_XML = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0.00 0.00 1773.00 1773.00">
<g stroke-width="2.00" fill="none" stroke-linecap="butt">
<path stroke="#939f89" vector-effect="non-scaling-stroke" d="
  M 1115.69 553.16
  L 1115.67 641.50
  A 0.55 0.55 0.0 0 1 1114.77 641.92
  Q 1087.92 620.16 1070.31 605.48
  C 1047.96 586.84 1022.72 567.26 1003.17 550.49
  C 994.48 543.04 986.23 537.00 976.33 528.69
  Q 969.97 523.36 956.25 512.27
  Q 929.21 490.41 901.45 467.24
  Q 896.25 462.90 894.64 461.95
  C 885.06 456.31 878.78 461.57 871.61 467.34
  C 827.92 502.53 787.23 536.57 744.73 571.05
  Q 722.03 589.46 697.18 609.67
  C 662.69 637.72 625.73 668.25 593.96 694.12
  Q 434.89 823.66 347.69 894.93
  Q 288.96 942.93 280.11 950.19
  Q 275.64 953.85 274.15 956.05
  C 270.31 961.69 269.70 969.48 273.72 975.05
  Q 285.33 991.10 304.40 1015.34
  C 310.19 1022.69 319.58 1025.48 327.84 1020.10
  C 330.44 1018.41 332.19 1017.39 333.98 1015.85
  Q 353.35 999.27 370.31 985.87
  C 385.30 974.04 397.12 963.47 411.64 951.84
  Q 435.66 932.63 442.85 926.57
  Q 458.78 913.15 534.75 851.75
  Q 542.81 845.23 584.49 810.77
  Q 597.27 800.21 602.40 796.13
  C 618.43 783.41 631.57 771.92 647.16 759.52
  Q 674.19 738.01 694.31 721.18
  C 708.33 709.45 722.57 698.46 736.47 686.90
  C 768.49 660.28 801.61 633.65 832.85 607.69
  C 842.68 599.52 858.52 587.07 870.95 576.45
  C 874.87 573.10 881.88 567.43 887.77 567.99
  C 891.02 568.31 895.73 571.32 897.87 573.21
  Q 902.43 577.23 918.06 590.05
  Q 966.37 629.65 1014.65 668.97
  Q 1111.54 747.87 1222.34 838.40
  Q 1248.79 860.01 1441.69 1017.80
  C 1452.17 1026.37 1462.27 1023.15 1470.22 1013.72
  Q 1475.51 1007.45 1490.58 987.18
  C 1493.64 983.05 1498.78 978.20 1500.38 974.60
  Q 1506.45 961.02 1494.92 951.60
  Q 1441.58 907.98 1419.24 890.22
  C 1410.58 883.32 1402.01 875.71 1393.20 868.79
  Q 1386.43 863.47 1373.58 852.90
  C 1330.98 817.86 1299.97 792.36 1270.14 768.54
  Q 1267.93 766.77 1267.93 764.75
  Q 1267.88 722.28 1267.95 679.22"
/>
<path stroke="#857427" vector-effect="non-scaling-stroke" d="
  M 1267.95 679.22
  L 1359.85 753.70
  A 1.25 1.25 0.0 0 0 1361.50 753.65
  Q 1375.48 740.53 1387.92 726.40
  Q 1422.64 686.97 1439.76 637.37
  Q 1444.61 623.32 1447.15 610.77
  C 1452.05 586.57 1454.43 562.26 1452.64 537.86
  C 1450.65 510.69 1445.47 484.02 1435.16 458.32
  Q 1428.15 440.83 1422.50 430.02
  Q 1410.94 407.88 1392.86 385.20
  C 1385.33 375.76 1375.63 366.52 1366.24 357.51
  Q 1361.46 352.93 1350.41 344.58
  Q 1304.09 309.55 1250.03 297.19
  C 1144.41 273.05 1032.97 316.19 973.06 406.28
  Q 965.34 417.89 960.10 427.25
  A 1.44 1.43 34.8 0 0 960.43 429.06
  Q 974.15 440.54 982.81 447.36
  C 1000.19 461.05 1013.88 472.60 1031.57 486.54
  Q 1036.01 490.04 1042.43 495.59
  C 1051.34 503.30 1060.99 510.35 1070.13 517.87
  Q 1083.63 528.98 1098.45 541.06
  Q 1107.77 548.66 1115.69 553.16"
/>
<path stroke="#eac67b" vector-effect="non-scaling-stroke" d="
  M 1267.95 679.22
  Q 1267.83 677.44 1267.83 675.00
  Q 1267.67 539.06 1267.64 537.31
  Q 1267.49 525.10 1267.32 521.50
  C 1266.98 514.11 1262.17 508.60 1255.09 506.84
  Q 1251.88 506.05 1246.34 506.03
  Q 1179.77 505.79 1135.01 506.04
  C 1127.30 506.08 1120.49 509.53 1117.61 516.75
  Q 1116.55 519.39 1116.41 525.53
  Q 1116.11 539.13 1115.69 553.16"
/>
<path stroke="#939f89" vector-effect="non-scaling-stroke" d="
  M 625.61 1478.82
  Q 625.81 1476.79 625.81 1475.50
  Q 625.91 1458.44 625.88 1136.51
  Q 625.88 1129.56 626.69 1127.06
  C 628.53 1121.44 634.33 1115.79 640.26 1115.72
  Q 659.93 1115.48 802.25 1115.58
  Q 807.61 1115.59 809.60 1116.46
  Q 818.98 1120.55 822.16 1130.23
  A 4.91 4.82 36.3 0 1 822.39 1131.64
  L 822.68 1478.77
  A 0.39 0.39 0.0 0 0 823.06 1479.16
  Q 825.99 1479.24 831.25 1479.25
  Q 1058.05 1479.46 1337.50 1479.29
  Q 1344.11 1479.29 1347.23 1478.39
  C 1354.90 1476.19 1359.82 1468.07 1360.60 1460.08
  Q 1360.83 1457.78 1360.83 1448.90
  Q 1360.77 1283.19 1360.95 1028.91
  Q 1360.96 1020.69 1359.90 1017.51
  C 1357.45 1010.12 1352.16 1005.91 1345.82 1000.74
  Q 1243.66 917.46 1181.25 866.32
  C 1166.38 854.14 1155.61 845.63 1143.58 835.76
  Q 1044.24 754.25 957.28 683.58
  C 940.68 670.09 920.51 653.26 899.27 636.14
  Q 892.22 630.45 889.29 629.70
  Q 883.70 628.25 878.18 632.68
  Q 848.00 656.89 809.84 688.05
  Q 796.81 698.69 782.61 710.36
  C 708.91 770.96 641.45 825.46 576.40 879.08
  Q 566.06 887.60 549.56 900.89
  Q 538.59 909.72 522.76 922.74
  Q 514.14 929.83 507.93 934.94
  Q 452.09 980.89 432.96 996.20
  C 424.95 1002.60 413.07 1011.11 412.95 1022.67
  Q 412.56 1060.39 412.56 1061.00
  Q 412.85 1217.28 412.74 1451.10
  C 412.74 1459.32 412.56 1464.95 416.53 1470.95
  Q 420.18 1476.46 427.03 1478.56
  C 429.70 1479.38 434.84 1479.32 437.00 1479.31
  Q 519.29 1479.21 625.06 1479.33
  A 0.57 0.55 -87.1 0 0 625.61 1478.82"
/>
<path stroke="#939f89" vector-effect="non-scaling-stroke" d="
  M 1163.02 1131.48
  A 15.93 15.93 0.0 0 0 1147.09 1115.55
  L 1013.85 1115.55
  A 15.93 15.93 0.0 0 0 997.92 1131.48
  L 997.92 1266.44
  A 15.93 15.93 0.0 0 0 1013.85 1282.37
  L 1147.09 1282.37
  A 15.93 15.93 0.0 0 0 1163.02 1266.44
  L 1163.02 1131.48"
/>
</g>
<path fill="#2e4d35" d="
  M 1466.97 0.00
  Q 1480.99 1.26 1495.00 2.49
  Q 1526.93 5.30 1557.03 15.20
  Q 1561.47 16.66 1577.84 22.85
  C 1582.33 24.55 1585.47 26.28 1589.39 27.93
  Q 1599.02 31.98 1610.94 38.83
  C 1631.93 50.89 1652.13 64.72 1669.30 80.59
  C 1675.86 86.65 1681.64 91.78 1687.45 97.97
  Q 1718.38 130.94 1738.05 169.25
  C 1743.42 179.70 1746.42 184.84 1749.77 193.86
  Q 1758.27 216.79 1761.06 226.69
  C 1767.57 249.71 1770.97 274.24 1773.00 298.66
  L 1773.00 1475.15
  Q 1770.03 1514.31 1759.25 1552.00
  Q 1759.19 1552.19 1759.21 1552.78
  A 1.52 1.50 61.3 0 1 1758.95 1553.69
  C 1756.96 1556.61 1756.58 1560.82 1755.31 1563.93
  C 1753.20 1569.13 1751.57 1575.16 1749.77 1579.54
  Q 1737.73 1608.94 1721.09 1634.34
  Q 1708.88 1652.97 1697.44 1664.94
  C 1684.58 1678.39 1669.34 1694.95 1653.27 1707.45
  Q 1633.05 1723.17 1608.61 1736.20
  Q 1606.46 1737.34 1606.10 1737.63
  C 1604.24 1739.12 1601.70 1739.60 1599.55 1740.69
  Q 1589.98 1745.53 1587.15 1746.69
  Q 1576.45 1751.08 1552.30 1759.18
  Q 1541.20 1762.90 1528.73 1765.19
  Q 1509.36 1768.74 1497.81 1770.54
  Q 1494.15 1771.11 1492.01 1771.74
  C 1490.02 1772.32 1488.39 1772.57 1486.57 1773.00
  L 288.60 1773.00
  C 282.33 1771.95 275.70 1770.20 269.95 1769.32
  C 250.53 1766.35 231.97 1762.71 214.51 1756.76
  Q 203.76 1753.10 197.49 1751.09
  C 195.27 1750.37 193.10 1748.98 190.68 1748.65
  A 4.10 4.02 62.6 0 1 189.28 1748.19
  Q 183.72 1745.18 179.20 1743.44
  Q 174.19 1741.50 171.43 1739.66
  Q 170.36 1738.95 163.66 1735.85
  Q 163.07 1735.58 162.25 1734.78
  A 4.54 4.40 77.9 0 0 160.94 1733.90
  Q 156.94 1732.17 153.54 1730.20
  Q 132.13 1717.80 113.46 1702.76
  C 110.74 1700.57 108.24 1697.67 105.89 1696.39
  A 5.45 5.34 -5.5 0 1 104.44 1695.22
  C 102.30 1692.77 99.47 1691.21 97.36 1689.07
  Q 85.49 1677.03 84.56 1676.19
  C 83.73 1675.44 82.92 1673.70 81.93 1672.81
  Q 79.43 1670.56 77.95 1668.53
  Q 76.37 1666.38 73.96 1663.88
  Q 71.26 1661.08 66.89 1655.36
  Q 56.56 1641.86 46.72 1626.32
  Q 36.91 1610.80 29.95 1595.21
  Q 21.54 1576.39 14.07 1552.21
  Q 5.44 1524.25 2.49 1495.00
  Q 1.31 1483.25 0.00 1471.50
  L 0.00 301.46
  Q 1.26 289.63 2.40 277.77
  Q 5.33 247.11 14.27 220.26
  Q 19.59 204.29 23.90 193.40
  Q 25.31 189.84 31.10 177.60
  A 5.52 4.47 -30.9 0 0 31.39 176.81
  Q 31.99 174.64 33.28 173.16
  A 4.64 4.56 -13.5 0 0 33.95 172.09
  Q 35.70 168.11 38.15 163.69
  Q 84.25 80.90 167.48 36.01
  C 169.31 35.02 172.22 34.03 174.26 32.36
  A 2.52 2.44 15.4 0 1 175.12 31.89
  C 178.79 30.79 183.08 27.86 186.22 26.90
  C 189.23 25.98 191.88 24.25 195.39 22.96
  Q 217.26 14.91 222.70 13.25
  Q 248.23 5.45 272.76 2.62
  Q 283.93 1.33 301.33 0.00
  L 1466.97 0.00
  Z
  M 1115.69 553.16
  L 1115.67 641.50
  A 0.55 0.55 0.0 0 1 1114.77 641.92
  Q 1087.92 620.16 1070.31 605.48
  C 1047.96 586.84 1022.72 567.26 1003.17 550.49
  C 994.48 543.04 986.23 537.00 976.33 528.69
  Q 969.97 523.36 956.25 512.27
  Q 929.21 490.41 901.45 467.24
  Q 896.25 462.90 894.64 461.95
  C 885.06 456.31 878.78 461.57 871.61 467.34
  C 827.92 502.53 787.23 536.57 744.73 571.05
  Q 722.03 589.46 697.18 609.67
  C 662.69 637.72 625.73 668.25 593.96 694.12
  Q 434.89 823.66 347.69 894.93
  Q 288.96 942.93 280.11 950.19
  Q 275.64 953.85 274.15 956.05
  C 270.31 961.69 269.70 969.48 273.72 975.05
  Q 285.33 991.10 304.40 1015.34
  C 310.19 1022.69 319.58 1025.48 327.84 1020.10
  C 330.44 1018.41 332.19 1017.39 333.98 1015.85
  Q 353.35 999.27 370.31 985.87
  C 385.30 974.04 397.12 963.47 411.64 951.84
  Q 435.66 932.63 442.85 926.57
  Q 458.78 913.15 534.75 851.75
  Q 542.81 845.23 584.49 810.77
  Q 597.27 800.21 602.40 796.13
  C 618.43 783.41 631.57 771.92 647.16 759.52
  Q 674.19 738.01 694.31 721.18
  C 708.33 709.45 722.57 698.46 736.47 686.90
  C 768.49 660.28 801.61 633.65 832.85 607.69
  C 842.68 599.52 858.52 587.07 870.95 576.45
  C 874.87 573.10 881.88 567.43 887.77 567.99
  C 891.02 568.31 895.73 571.32 897.87 573.21
  Q 902.43 577.23 918.06 590.05
  Q 966.37 629.65 1014.65 668.97
  Q 1111.54 747.87 1222.34 838.40
  Q 1248.79 860.01 1441.69 1017.80
  C 1452.17 1026.37 1462.27 1023.15 1470.22 1013.72
  Q 1475.51 1007.45 1490.58 987.18
  C 1493.64 983.05 1498.78 978.20 1500.38 974.60
  Q 1506.45 961.02 1494.92 951.60
  Q 1441.58 907.98 1419.24 890.22
  C 1410.58 883.32 1402.01 875.71 1393.20 868.79
  Q 1386.43 863.47 1373.58 852.90
  C 1330.98 817.86 1299.97 792.36 1270.14 768.54
  Q 1267.93 766.77 1267.93 764.75
  Q 1267.88 722.28 1267.95 679.22
  L 1359.85 753.70
  A 1.25 1.25 0.0 0 0 1361.50 753.65
  Q 1375.48 740.53 1387.92 726.40
  Q 1422.64 686.97 1439.76 637.37
  Q 1444.61 623.32 1447.15 610.77
  C 1452.05 586.57 1454.43 562.26 1452.64 537.86
  C 1450.65 510.69 1445.47 484.02 1435.16 458.32
  Q 1428.15 440.83 1422.50 430.02
  Q 1410.94 407.88 1392.86 385.20
  C 1385.33 375.76 1375.63 366.52 1366.24 357.51
  Q 1361.46 352.93 1350.41 344.58
  Q 1304.09 309.55 1250.03 297.19
  C 1144.41 273.05 1032.97 316.19 973.06 406.28
  Q 965.34 417.89 960.10 427.25
  A 1.44 1.43 34.8 0 0 960.43 429.06
  Q 974.15 440.54 982.81 447.36
  C 1000.19 461.05 1013.88 472.60 1031.57 486.54
  Q 1036.01 490.04 1042.43 495.59
  C 1051.34 503.30 1060.99 510.35 1070.13 517.87
  Q 1083.63 528.98 1098.45 541.06
  Q 1107.77 548.66 1115.69 553.16
  Z
  M 625.61 1478.82
  Q 625.81 1476.79 625.81 1475.50
  Q 625.91 1458.44 625.88 1136.51
  Q 625.88 1129.56 626.69 1127.06
  C 628.53 1121.44 634.33 1115.79 640.26 1115.72
  Q 659.93 1115.48 802.25 1115.58
  Q 807.61 1115.59 809.60 1116.46
  Q 818.98 1120.55 822.16 1130.23
  A 4.91 4.82 36.3 0 1 822.39 1131.64
  L 822.68 1478.77
  A 0.39 0.39 0.0 0 0 823.06 1479.16
  Q 825.99 1479.24 831.25 1479.25
  Q 1058.05 1479.46 1337.50 1479.29
  Q 1344.11 1479.29 1347.23 1478.39
  C 1354.90 1476.19 1359.82 1468.07 1360.60 1460.08
  Q 1360.83 1457.78 1360.83 1448.90
  Q 1360.77 1283.19 1360.95 1028.91
  Q 1360.96 1020.69 1359.90 1017.51
  C 1357.45 1010.12 1352.16 1005.91 1345.82 1000.74
  Q 1243.66 917.46 1181.25 866.32
  C 1166.38 854.14 1155.61 845.63 1143.58 835.76
  Q 1044.24 754.25 957.28 683.58
  C 940.68 670.09 920.51 653.26 899.27 636.14
  Q 892.22 630.45 889.29 629.70
  Q 883.70 628.25 878.18 632.68
  Q 848.00 656.89 809.84 688.05
  Q 796.81 698.69 782.61 710.36
  C 708.91 770.96 641.45 825.46 576.40 879.08
  Q 566.06 887.60 549.56 900.89
  Q 538.59 909.72 522.76 922.74
  Q 514.14 929.83 507.93 934.94
  Q 452.09 980.89 432.96 996.20
  C 424.95 1002.60 413.07 1011.11 412.95 1022.67
  Q 412.56 1060.39 412.56 1061.00
  Q 412.85 1217.28 412.74 1451.10
  C 412.74 1459.32 412.56 1464.95 416.53 1470.95
  Q 420.18 1476.46 427.03 1478.56
  C 429.70 1479.38 434.84 1479.32 437.00 1479.31
  Q 519.29 1479.21 625.06 1479.33
  A 0.57 0.55 -87.1 0 0 625.61 1478.82
  Z"
/>
<path fill="#dc9a18" d="
  M 1267.95 679.22
  Q 1267.83 677.44 1267.83 675.00
  Q 1267.67 539.06 1267.64 537.31
  Q 1267.49 525.10 1267.32 521.50
  C 1266.98 514.11 1262.17 508.60 1255.09 506.84
  Q 1251.88 506.05 1246.34 506.03
  Q 1179.77 505.79 1135.01 506.04
  C 1127.30 506.08 1120.49 509.53 1117.61 516.75
  Q 1116.55 519.39 1116.41 525.53
  Q 1116.11 539.13 1115.69 553.16
  Q 1107.77 548.66 1098.45 541.06
  Q 1083.63 528.98 1070.13 517.87
  C 1060.99 510.35 1051.34 503.30 1042.43 495.59
  Q 1036.01 490.04 1031.57 486.54
  C 1013.88 472.60 1000.19 461.05 982.81 447.36
  Q 974.15 440.54 960.43 429.06
  A 1.44 1.43 34.8 0 1 960.10 427.25
  Q 965.34 417.89 973.06 406.28
  C 1032.97 316.19 1144.41 273.05 1250.03 297.19
  Q 1304.09 309.55 1350.41 344.58
  Q 1361.46 352.93 1366.24 357.51
  C 1375.63 366.52 1385.33 375.76 1392.86 385.20
  Q 1410.94 407.88 1422.50 430.02
  Q 1428.15 440.83 1435.16 458.32
  C 1445.47 484.02 1450.65 510.69 1452.64 537.86
  C 1454.43 562.26 1452.05 586.57 1447.15 610.77
  Q 1444.61 623.32 1439.76 637.37
  Q 1422.64 686.97 1387.92 726.40
  Q 1375.48 740.53 1361.50 753.65
  A 1.25 1.25 0.0 0 1 1359.85 753.70
  L 1267.95 679.22
  Z"
/>
<path fill="#f8f1dd" d="
  M 1115.69 553.16
  Q 1116.11 539.13 1116.41 525.53
  Q 1116.55 519.39 1117.61 516.75
  C 1120.49 509.53 1127.30 506.08 1135.01 506.04
  Q 1179.77 505.79 1246.34 506.03
  Q 1251.88 506.05 1255.09 506.84
  C 1262.17 508.60 1266.98 514.11 1267.32 521.50
  Q 1267.49 525.10 1267.64 537.31
  Q 1267.67 539.06 1267.83 675.00
  Q 1267.83 677.44 1267.95 679.22
  Q 1267.88 722.28 1267.93 764.75
  Q 1267.93 766.77 1270.14 768.54
  C 1299.97 792.36 1330.98 817.86 1373.58 852.90
  Q 1386.43 863.47 1393.20 868.79
  C 1402.01 875.71 1410.58 883.32 1419.24 890.22
  Q 1441.58 907.98 1494.92 951.60
  Q 1506.45 961.02 1500.38 974.60
  C 1498.78 978.20 1493.64 983.05 1490.58 987.18
  Q 1475.51 1007.45 1470.22 1013.72
  C 1462.27 1023.15 1452.17 1026.37 1441.69 1017.80
  Q 1248.79 860.01 1222.34 838.40
  Q 1111.54 747.87 1014.65 668.97
  Q 966.37 629.65 918.06 590.05
  Q 902.43 577.23 897.87 573.21
  C 895.73 571.32 891.02 568.31 887.77 567.99
  C 881.88 567.43 874.87 573.10 870.95 576.45
  C 858.52 587.07 842.68 599.52 832.85 607.69
  C 801.61 633.65 768.49 660.28 736.47 686.90
  C 722.57 698.46 708.33 709.45 694.31 721.18
  Q 674.19 738.01 647.16 759.52
  C 631.57 771.92 618.43 783.41 602.40 796.13
  Q 597.27 800.21 584.49 810.77
  Q 542.81 845.23 534.75 851.75
  Q 458.78 913.15 442.85 926.57
  Q 435.66 932.63 411.64 951.84
  C 397.12 963.47 385.30 974.04 370.31 985.87
  Q 353.35 999.27 333.98 1015.85
  C 332.19 1017.39 330.44 1018.41 327.84 1020.10
  C 319.58 1025.48 310.19 1022.69 304.40 1015.34
  Q 285.33 991.10 273.72 975.05
  C 269.70 969.48 270.31 961.69 274.15 956.05
  Q 275.64 953.85 280.11 950.19
  Q 288.96 942.93 347.69 894.93
  Q 434.89 823.66 593.96 694.12
  C 625.73 668.25 662.69 637.72 697.18 609.67
  Q 722.03 589.46 744.73 571.05
  C 787.23 536.57 827.92 502.53 871.61 467.34
  C 878.78 461.57 885.06 456.31 894.64 461.95
  Q 896.25 462.90 901.45 467.24
  Q 929.21 490.41 956.25 512.27
  Q 969.97 523.36 976.33 528.69
  C 986.23 537.00 994.48 543.04 1003.17 550.49
  C 1022.72 567.26 1047.96 586.84 1070.31 605.48
  Q 1087.92 620.16 1114.77 641.92
  A 0.55 0.55 0.0 0 0 1115.67 641.50
  L 1115.69 553.16
  Z"
/>
<path fill="#f8f1dd" d="
  M 625.61 1478.82
  A 0.57 0.55 -87.1 0 1 625.06 1479.33
  Q 519.29 1479.21 437.00 1479.31
  C 434.84 1479.32 429.70 1479.38 427.03 1478.56
  Q 420.18 1476.46 416.53 1470.95
  C 412.56 1464.95 412.74 1459.32 412.74 1451.10
  Q 412.85 1217.28 412.56 1061.00
  Q 412.56 1060.39 412.95 1022.67
  C 413.07 1011.11 424.95 1002.60 432.96 996.20
  Q 452.09 980.89 507.93 934.94
  Q 514.14 929.83 522.76 922.74
  Q 538.59 909.72 549.56 900.89
  Q 566.06 887.60 576.40 879.08
  C 641.45 825.46 708.91 770.96 782.61 710.36
  Q 796.81 698.69 809.84 688.05
  Q 848.00 656.89 878.18 632.68
  Q 883.70 628.25 889.29 629.70
  Q 892.22 630.45 899.27 636.14
  C 920.51 653.26 940.68 670.09 957.28 683.58
  Q 1044.24 754.25 1143.58 835.76
  C 1155.61 845.63 1166.38 854.14 1181.25 866.32
  Q 1243.66 917.46 1345.82 1000.74
  C 1352.16 1005.91 1357.45 1010.12 1359.90 1017.51
  Q 1360.96 1020.69 1360.95 1028.91
  Q 1360.77 1283.19 1360.83 1448.90
  Q 1360.83 1457.78 1360.60 1460.08
  C 1359.82 1468.07 1354.90 1476.19 1347.23 1478.39
  Q 1344.11 1479.29 1337.50 1479.29
  Q 1058.05 1479.46 831.25 1479.25
  Q 825.99 1479.24 823.06 1479.16
  A 0.39 0.39 0.0 0 1 822.68 1478.77
  L 822.39 1131.64
  A 4.91 4.82 36.3 0 0 822.16 1130.23
  Q 818.98 1120.55 809.60 1116.46
  Q 807.61 1115.59 802.25 1115.58
  Q 659.93 1115.48 640.26 1115.72
  C 634.33 1115.79 628.53 1121.44 626.69 1127.06
  Q 625.88 1129.56 625.88 1136.51
  Q 625.91 1458.44 625.81 1475.50
  Q 625.81 1476.79 625.61 1478.82
  Z
  M 1163.02 1131.48
  A 15.93 15.93 0.0 0 0 1147.09 1115.55
  L 1013.85 1115.55
  A 15.93 15.93 0.0 0 0 997.92 1131.48
  L 997.92 1266.44
  A 15.93 15.93 0.0 0 0 1013.85 1282.37
  L 1147.09 1282.37
  A 15.93 15.93 0.0 0 0 1163.02 1266.44
  L 1163.02 1131.48
  Z"
/>
<rect fill="#2e4d35" x="997.92" y="1115.55" width="165.10" height="166.82" rx="15.93"/>
</svg>`;
